
import React, { useState } from "react"
import { navigate } from "gatsby"
import { Button, Col, Form, Row } from 'react-bootstrap'

const Contact = () => {

    let [name, setName] = useState('');
    let [email, setEmail] = useState('');
    let [disableButton, setDisabledSubmit] = useState(false);

    const submit = (event) => {
        event.preventDefault();
        setDisabledSubmit(true);
        
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            mode: 'no-cors',
            body: JSON.stringify({
                "company":"",
                "name":name,
                "email":email,
                "message":""
        
            })
        };

        fetch("https://formsubmithttp.azurewebsites.net/api/FormSubmitHTTP?code=ZPmNrdS0MEMSal166V0MB8nqpdaX9ReKy/1A4Gzs9LynTDba0mC4ag==", requestOptions)
            .then(response => {
                console.log('success'); 
                navigate('/form-submission/thank-you');
            })
            .catch(error => {
                console.error('error occurred')
            });
    };

    return (
        <Form onSubmit={submit}>
            <Row className="justify-content-md-center">
                <Col className="py-1" lg={3}>
                    <Form.Control 
                        onChange={e => setName(e.target.value)}
                        placeholder="Name"
                        required
                        type="text"></Form.Control>
                </Col>
                <Col className="py-1" lg={3}>
                    <Form.Control 
                        onChange={e => setEmail(e.target.value)}
                        placeholder="Email"
                        required
                        type="email"></Form.Control>
                </Col>
                <Col className="py-1 d-flex justify-content-end" lg={1}>
                    <Button type="submit" disabled={disableButton}>Submit</Button>
                </Col>
            </Row>
        </Form>
    )
}

export default Contact